import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import NumberFormat from 'react-number-format';
import Select from 'react-select';

// CKeditor
import CKEditor from 'react-ckeditor-component';
import { editorReady } from '../../../utils/editor';

// Components
import FieldHelp from '../../utils/FieldHelp';
import Loader from '../../utils/Loader';
import PermalinkField from '../../utils/PermalinkField';
import GeolocationField from '../../utils/GeolocationField';
import DeleteConfirmationDialog from '../../utils/DeleteConfirmationDialog';

// CSS
import '../../../css/react-select.css';

// State
import { getLocations, getProvinces } from '../../../store/actions/locations';
import { userTokenUpdate } from '../../../store/actions/user';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars';

class AdminStoreLocationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                id: null,
                title: '',
                permalink: !!props.match.params.permalink
                    ? props.match.params.permalink
                    : '',
                email: '',
                address: '',
                city: '',
                postal: '',
                country: '',
                province: '',
                phone: '',
                extension: '',
                shipping_cost: '',
                description: '',
                allow_pickup_times: true,
            },
            isLoading: !!props.match.params.permalink ? true : false,
            addSucccess: !!props.location.state
                ? props.location.state.successMessage
                : '',
            updateLoading: false,
            updateErrors: {},
            updateSuccess: '',
            showDeleteConfirmationDialog: false,
            deletionInProgress: false,
            deleteErrors: '',
            deleteSuccess: '',
        };

        // Remove state from history object (success messages, etc)
        if (!!props.location.state) {
            props.history.replace({
                pathname: props.history.location.pathname,
            });
        }
    }

    componentDidMount() {
        this.props.getLocations();

        if (this.state.data.permalink) {
            this.loadData();
        }
    }

    loadData() {
        this.setState(
            {
                isLoading: true,
            },
            () => {
                const { permalink } = this.state.data;

                const apiEndpoint = 'store-locations/' + permalink;

                const AUTH_HEADER = {
                    Authorization:
                        REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token,
                };
                return axios
                    .get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
                    .then((response) => {
                        if (
                            response.status !== 200 ||
                            (response.data.status && response.data.status !== 200)
                        ) {
                            this.setState({
                                isLoading: false,
                                error: response.data.message,
                            });
                        } else {
                            this.setState({
                                isLoading: false,
                                data: { ...response.data },
                            });
                        }
                    })
                    .catch((err) => {
                        if (err.response) {
                            this.setState({
                                isLoading: false,
                                error: err.response.data.errors
                                    ? err.response.data.errors
                                    : err.response.data.message,
                            });
                        } else {
                            this.setState({ isLoading: false, error: err.message });
                        }
                    });
            }
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.default_country !== null && this.state.data.country === '') {
            this.setState({
                data: {
                    ...this.state.data,
                    country: nextProps.default_country,
                },
            });
        }
    }

    updateSelectedCountry = (country) => {
        this.setState(
            {
                data: {
                    ...this.state.data,
                    country: country.id,
                    province: '',
                },
            },
            () => this.props.getProvinces(this.state.data.country)
        );
    };

    updateSelectedProvince = (province) => {
        this.setState({
            data: {
                ...this.state.data,
                province: province.abbreviation,
            },
        });
    };

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSubmit();
        }
    }

    handleInputChange(event) {
        const { id, value } = event.target;
        this.setState({
            data: {
                ...this.state.data,
                [id]: value,
            },
        });
    }

    editorChange(evt) {
        const newContent = evt.editor.getData();
        const newData = {
            ...this.state.data,
            description: newContent,
        };

        this.setState({ data: newData });
    }

    handleNumberChange(id, valueObject) {
        this.setState({
            data: {
                ...this.state.data,
                [id]: valueObject.value,
            },
        });
    }

    handleCheckboxClick() {
        this.setState({
            data: {
                ...this.state.data,
                allow_pickup_times: !this.state.data.allow_pickup_times,
            },
        });
    }

    handleSubmit() {
        const { user } = this.props;
        const { data } = this.state;

        this.setState({
            updateErrors: {},
            updateLoading: true,
        });

        const token = user.token;
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token };
        return axios
            .post(REACT_APP_API_URL + 'store-locations', data, { headers: AUTH_HEADER })
            .then((response) => {
                if (!!response.data.token) {
                    this.props.userTokenUpdate('admin', response.data.token);
                }

                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: !isEmpty(response.data.errors)
                            ? response.data.errors
                            : { general: response.data.message },
                    });
                } else {
                    // Redirect to store edit route
                    if (!data.id) {
                        this.props.history.push({
                            pathname:
                                '/admin/store-locations/edit/' + response.data.permalink,
                            state: {
                                successMessage: response.data.message,
                            },
                        });
                    }

                    // If editing, set state and formatted values (postal code, etc)
                    let formattedValues = response.data.formatted_values;

                    this.setState({
                        updateLoading: false,
                        updateSuccess: response.data.message,
                        data: {
                            ...this.state.data,
                            ...formattedValues,
                        },
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: {
                            general: err.response.data.error
                                ? err.response.data.error
                                : err.response.data.message,
                        },
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateErrors: { general: err.message },
                    });
                }
            });
    }

    handleDelete(permalink) {
        const { user } = this.props;

        this.setState({
            deletionInProgress: true,
            deleteErrors: {},
            deleteSuccess: '',
        });

        const token = user.token;
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token };
        return axios
            .delete(REACT_APP_API_URL + 'store-locations/' + permalink, {
                headers: AUTH_HEADER,
            })
            .then((response) => {
                if (!!response.data.token) {
                    this.props.userTokenUpdate('admin', response.data.token);
                }

                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({
                        deletionInProgress: false,
                        deleteErrors: !isEmpty(response.data.errors)
                            ? response.data.errors
                            : response.data.message,
                    });
                } else {
                    this.setState({
                        deletionInProgress: false,
                        deleteSuccess: response.data.message,
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        deletionInProgress: false,
                        deleteErrors: err.response.data.error
                            ? err.response.data.error
                            : err.response.data.message,
                    });
                } else {
                    this.setState({
                        deletionInProgress: false,
                        deleteErrors: err.message,
                    });
                }
            });
    }

    handleDeleteRedirect() {
        this.props.history.push('/admin/store-locations/edit/');
    }

    render() {
        const { locationsLoading, locationsError, countries, provinces } = this.props;
        const {
            addSucccess,
            updateLoading,
            updateSuccess,
            updateErrors,
            data,
        } = this.state;
        const {
            id,
            title,
            permalink,
            email,
            address,
            city,
            postal,
            country,
            province,
            phone,
            extension,
            shipping_cost,
            description,
            allow_pickup_times,
        } = data;
        return (
            <div>
                {!this.props.match.params.permalink && <h1>Add Store Location</h1>}

                {/* Loading */}
                {this.state.isLoading ? (
                    <div className="pt2 pb2">
                        <Loader />
                    </div>
                ) : (
                    <div>
                        {!!addSucccess && (
                            <div className="success msg_animate">{addSucccess}</div>
                        )}
                        {!this.props.match.params.permalink || id ? (
                            <div>
                                {!!id && <input type="hidden" id="id" value={id} />}

                                <div className="fieldset">
                                    <div className="form-field">
                                        <label htmlFor="title">Store Name:</label>

                                        {updateErrors.title && (
                                            <div className="error msg_animate">
                                                {updateErrors.title}
                                            </div>
                                        )}
                                        <input
                                            type="text"
                                            id="title"
                                            value={title}
                                            placeholder="Store Name"
                                            onKeyPress={(e) => this.handleKeyPress(e)}
                                            onChange={(e) => this.handleInputChange(e)}
                                        />
                                    </div>

                                    <div className="form-field">
                                        <label>Permalink:</label>

                                        {updateErrors.permalink && (
                                            <div className="error msg_animate">
                                                {updateErrors.permalink}
                                            </div>
                                        )}
                                        <PermalinkField
                                            tableName={'store_locations'}
                                            id={id}
                                            value={permalink}
                                            controlFieldValue={title}
                                            fieldError={updateErrors.permalink}
                                            handleSubmit={this.handleSubmit.bind(this)}
                                            handleChange={(res) =>
                                                this.setState({
                                                    data: {
                                                        ...this.state.data,
                                                        permalink: res,
                                                    },
                                                })
                                            }
                                        />
                                    </div>

                                    <div className="form-field">
                                        <label htmlFor="email">Email:</label>

                                        {updateErrors.email && (
                                            <div className="error msg_animate">
                                                {updateErrors.email}
                                            </div>
                                        )}
                                        <input
                                            type="email"
                                            id="email"
                                            value={email}
                                            placeholder="Email"
                                            onKeyPress={(e) => this.handleKeyPress(e)}
                                            onChange={(e) => this.handleInputChange(e)}
                                        />
                                    </div>
                                </div>

                                <div className="fieldset">
                                    <label className="title-label">Location Info</label>

                                    <div className="form-field">
                                        <label htmlFor="password">Address:</label>

                                        {updateErrors.address && (
                                            <div className="error msg_animate">
                                                {updateErrors.address}
                                            </div>
                                        )}
                                        <input
                                            type="text"
                                            id="address"
                                            value={address}
                                            placeholder="Address"
                                            onKeyPress={(e) => this.handleKeyPress(e)}
                                            onChange={(e) => this.handleInputChange(e)}
                                        />
                                    </div>

                                    <div className="floated-field-container">
                                        <div className="form-field half-field">
                                            <label htmlFor="city">City:</label>

                                            {updateErrors.city && (
                                                <div className="error msg_animate">
                                                    {updateErrors.city}
                                                </div>
                                            )}
                                            <input
                                                type="text"
                                                id="city"
                                                value={city}
                                                placeholder="City"
                                                onKeyPress={(e) => this.handleKeyPress(e)}
                                                onChange={(e) =>
                                                    this.handleInputChange(e)
                                                }
                                            />
                                        </div>

                                        <div className="form-field half-field">
                                            <label>Postal:</label>

                                            {updateErrors.postal && (
                                                <div className="error msg_animate">
                                                    {updateErrors.postal}
                                                </div>
                                            )}
                                            <GeolocationField
                                                value={postal}
                                                placeholder={'Postal Code'}
                                                handleSubmit={this.handleSubmit.bind(
                                                    this
                                                )}
                                                handleChange={(res) =>
                                                    this.setState({
                                                        data: {
                                                            ...this.state.data,
                                                            postal: res,
                                                        },
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>

                                    {locationsError ? (
                                        <div className="error top-margin">
                                            {locationsError}
                                        </div>
                                    ) : locationsLoading ? (
                                        <div className="pt2 pb2">
                                            <Loader />
                                        </div>
                                    ) : (
                                        <div className="floated-field-container">
                                            <div className="form-field half-field">
                                                <label htmlFor="country">Country:</label>

                                                {!!updateErrors.country && (
                                                    <div className="error msg_animate">
                                                        {updateErrors.country}
                                                    </div>
                                                )}

                                                <Select
                                                    classNamePrefix="react-select"
                                                    name={`country`}
                                                    placeholder="Country"
                                                    value={countries.filter(
                                                        ({ id }) => id === country
                                                    )}
                                                    onChange={(selection) =>
                                                        this.updateSelectedCountry(
                                                            selection
                                                        )
                                                    }
                                                    isClearable={false}
                                                    getOptionLabel={({ title }) => title}
                                                    getOptionValue={({ id }) => id}
                                                    options={countries}
                                                />
                                            </div>

                                            <div className="form-field half-field">
                                                <label htmlFor="province">
                                                    Province:
                                                </label>

                                                {!!updateErrors.province && (
                                                    <div className="error msg_animate">
                                                        {updateErrors.province}
                                                    </div>
                                                )}

                                                <Select
                                                    classNamePrefix="react-select"
                                                    name={`province`}
                                                    placeholder={
                                                        this.state.data.country === 'CA'
                                                            ? 'Province'
                                                            : 'State'
                                                    }
                                                    value={provinces.filter(
                                                        ({ abbreviation }) =>
                                                            abbreviation === province
                                                    )}
                                                    onChange={(selection) =>
                                                        this.updateSelectedProvince(
                                                            selection
                                                        )
                                                    }
                                                    isClearable={false}
                                                    getOptionLabel={({ name }) => name}
                                                    getOptionValue={({ abbreviation }) =>
                                                        abbreviation
                                                    }
                                                    options={provinces}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="fieldset">
                                    <div className="floated-field-container">
                                        <div className="form-field half-field">
                                            <label htmlFor="phone">Phone:</label>

                                            {!!updateErrors.phone && (
                                                <div className="error msg_animate">
                                                    {updateErrors.phone}
                                                </div>
                                            )}
                                            <NumberFormat
                                                value={phone}
                                                format="### ### ####"
                                                mask="_"
                                                placeholder="Phone number"
                                                onKeyPress={(e) => this.handleKeyPress(e)}
                                                onValueChange={(e) =>
                                                    this.handleNumberChange('phone', e)
                                                }
                                            />
                                        </div>

                                        <div className="form-field half-field">
                                            <label htmlFor="phone">Extension:</label>

                                            {!!updateErrors.extension && (
                                                <div className="error msg_animate">
                                                    {updateErrors.extension}
                                                </div>
                                            )}
                                            <input
                                                type="number"
                                                id="extension"
                                                value={extension}
                                                placeholder="Extension: 123"
                                                onKeyPress={(e) => this.handleKeyPress(e)}
                                                onChange={(e) =>
                                                    this.handleInputChange(e)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="floated-field-container">
                                        <div className="form-field half-field">
                                            <label htmlFor="phone">Shipping Cost:</label>

                                            {!!updateErrors.shipping_cost && (
                                                <div className="error msg_animate">
                                                    {updateErrors.shipping_cost}
                                                </div>
                                            )}
                                            <NumberFormat
                                                value={
                                                    !!shipping_cost ? shipping_cost : ''
                                                }
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                prefix={'$'}
                                                onKeyPress={(e) => this.handleKeyPress(e)}
                                                onValueChange={(e) =>
                                                    this.handleNumberChange(
                                                        'shipping_cost',
                                                        e
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="floated-field-container">
                                    <div className="form-field half-field">
                                        <FieldHelp
                                            label={'Pickup Times'}
                                            helpItem={{
                                                txt:
                                                    'When box is checked, the customer will be allowed to select their own pickup times for this store location.',
                                            }}
                                        />
                                        <div
                                            className="custom-label checkbox-label no-bottom-margin"
                                            style={{ marginTop: '0.75em' }}
                                        >
                                            <input
                                                type="checkbox"
                                                id="allow_pickup_times"
                                                checked={allow_pickup_times}
                                                onChange={(e) =>
                                                    this.handleCheckboxClick(e)
                                                }
                                            />
                                            <label htmlFor="allow_pickup_times">
                                                Allow
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="fieldset">
                                    <label className="title-label">Further Info</label>

                                    {!!updateErrors.description && (
                                        <div className="error msg_animate">
                                            {updateErrors.description}
                                        </div>
                                    )}
                                    <div className="form-field">
                                        <CKEditor
                                            scriptUrl="/ckeditor/ckeditor.js"
                                            content={description}
                                            config={{
                                                filebrowserImageBrowseUrl:
                                                    '/image-browser',
                                                filebrowserBrowseUrl: '/file-browser',
                                                uploadUrl: REACT_APP_API_URL + `files`,
                                            }}
                                            events={{
                                                instanceReady: editorReady.bind(this),
                                                change: this.editorChange.bind(this),
                                            }}
                                        />
                                    </div>
                                </div>

                                {updateSuccess && (
                                    <div className="success msg_animate">
                                        {updateSuccess}
                                    </div>
                                )}

                                <div className="btn_container">
                                    {!!updateErrors.general && (
                                        <div className="error msg_animate">
                                            {updateErrors.general}
                                        </div>
                                    )}

                                    <button
                                        className={
                                            'btn submit-btn' +
                                            (updateLoading ? ' loading' : '')
                                        }
                                        onClick={() => this.handleSubmit()}
                                        disabled={updateLoading}
                                    >
                                        <span>{!!id ? 'Update' : 'Create'}</span>
                                    </button>
                                    {!!id && (
                                        <button
                                            className={
                                                'btn delete-btn' +
                                                (updateLoading ? ' loading' : '')
                                            }
                                            onClick={() =>
                                                this.setState({
                                                    showDeleteConfirmationDialog: true,
                                                })
                                            }
                                            disabled={updateLoading}
                                        >
                                            Delete
                                        </button>
                                    )}

                                    <DeleteConfirmationDialog
                                        show={this.state.showDeleteConfirmationDialog}
                                        deletionInProgress={this.state.deletionInProgress}
                                        id={permalink}
                                        itemTitle={title}
                                        handleDelete={this.handleDelete.bind(this)}
                                        handleDeleteRedirect={this.handleDeleteRedirect.bind(
                                            this
                                        )}
                                        handleClose={() =>
                                            this.setState({
                                                showDeleteConfirmationDialog: false,
                                            })
                                        }
                                        deleteErrors={this.state.deleteErrors}
                                        deleteSuccess={this.state.deleteSuccess}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div>Location not found</div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error,
    };
};

export default connect(
    mapStateToProps,
    { getLocations, getProvinces, userTokenUpdate }
)(AdminStoreLocationForm);



// WEBPACK FOOTER //
// ./src/components/admin/store-locations/AdminStoreLocationForm.js